import { options } from "./client"
import { SanityFileSource, tryGetFileAsset } from "@sanity/asset-utils"

export const getFileUrl = (asset: SanityFileSource) => {
  const file = tryGetFileAsset(asset, options).url

  if (file) {
    return file.url  
  } else {
    return 'undefined'  
  }
}
